import {get, getPaginated, put, post, RequestFilter, RequestOrder} from "../common/methods/ApiService";
import {API_URL, companyUrl} from "../common/struct/urlManager";
import {TPaymentIntent} from "../interfaces/payment";
import {TWalletTransaction} from "../interfaces/wallet";

export async function getCompanyWalletTransactions(companyId: string, page: number, itemsPerPage: number, search: string|null, order: RequestOrder|null, filters: RequestFilter[]): Promise<{totalItems: number, items: TWalletTransaction[]}> {
  return getPaginated(`${API_URL.COMPANY}/${companyId}/transactions-paid`, page, itemsPerPage, search, order, filters);
}

export async function getCompanyWalletTransactionsCount(companyId: string, filters: RequestFilter[]): Promise<{totalItems: number, items: TWalletTransaction[]}> {
  return getPaginated(`${API_URL.COMPANY}/${companyId}/transactions-paid`, 1, 0, null, null, filters);
}

export async function initStripePayment(walletTransactionId: string): Promise<TPaymentIntent> {
  return get(companyUrl(API_URL.TRANSACTION_STRIPE_INTENT, walletTransactionId));
}

export async function updateTransactionStatus(id: string): Promise<void> {
  return post(`${API_URL.WALLET_TRANSACTIONS}/${id}/ongoing`, {});
}

export async function updateTransactionReference(id: string, reference: string|null): Promise<void> {
  return put(API_URL.WALLET_TRANSACTIONS, id, {reference: reference});
}